var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootstepsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4173 2.9165C12.9215 2.9165 5.83398 12.8332 5.83398 23.3332C5.83398 27.6498 6.50482 31.7623 7.20482 34.9998H27.2131C27.709 33.4248 28.3215 31.8498 28.9632 30.2457C30.509 26.3957 32.084 22.429 32.084 17.4998C32.084 10.2665 28.059 2.9165 20.4173 2.9165ZM8.75065 46.6665C8.75065 51.479 12.6882 55.4165 17.5007 55.4165C22.3132 55.4165 26.2506 51.479 26.2506 46.6665V40.8332H8.75065V46.6665ZM49.584 14.5832C41.9423 14.5832 37.9173 21.904 37.9173 29.1665C37.9173 34.0957 39.4923 38.0623 41.0381 41.9123C41.6798 43.5165 42.2923 45.0623 42.7881 46.6665H62.7965C63.4965 43.429 64.1673 39.3165 64.1673 34.9998C64.1673 24.4998 57.0798 14.5832 49.584 14.5832ZM43.7506 58.3332C43.7506 63.1457 47.6881 67.0832 52.5006 67.0832C57.3131 67.0832 61.2506 63.1457 61.2506 58.3332V52.4998H43.7506V58.3332Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootstepsFilled);
export default __webpack_public_path__ + "static/media/footsteps-filled.95208d0a22b4b88495c3c82bca6eb19c.svg";
export { ForwardRef as ReactComponent };